// 在布局内需忽略显示的字段
export const IGNORE_FIELDS_IN_LAYOUT: string[] = ['epic', 'comments', 'activities', 'status', 'issueTypeId', 'sprint'];

// 左侧允许放置字段与类型 or 右侧不可放置字段与类型
export const PLACABLE_FIELDS_LEFT: string[] = ['summary', 'attachment', 'subtask', 'relationship', 'rich-text', 'docs']; 

// 不可移除字段
export const FIXED_FIELDS: string[] = ['assignee', 'owner', 'summary'];

// 不可移除但可拖拽排序字段
export const FIXED_SORT_FIELDS: string[] = ['docs'];

// 不可必填字段
export const UN_REQUIRED_FIELDS: string[] = ['docs'];

// 可以通过点击控制显隐的字段
export const VISIBLE_FIELDS: string[] = ['owner'];

// 可以编辑的系统字段
export const CAN_EDIT_FIELDS: string[] = ['summary', 'estimatePoint', 'owner', 'dueDate', 'priority', 'assignee', 'follows', 'description'];
